import { useMemo } from 'react';
import { useMediaQuery } from '@mantine/hooks';

export function useDeviceType() {
  const isDesktop = useMediaQuery(`(min-width: 768px)`) ?? false;

  return useMemo(
    () => ({
      desktop: isDesktop,
      mobile: !isDesktop,
    }),
    [isDesktop],
  );
}
